export enum BookingRoutes {
  bookings = 'bookings',
  dashboard = 'dashboard',
  waitlist = 'waitlist',
  tasks = 'tasks',
  tab = 'tab',
  details = 'details',
  list ='list',
  info = 'info',
  edit= 'edit'
}
export enum BookingTabsRoute {
  Details = 'details',
  Overview = 'overview',
  Catering = 'request',
  Documents = 'documents',
  Comments = 'comments',
  Expenses = 'expenses',
  AuditTrail = 'audit-trail',
  AddExpense = 'add-expense',
  EditExpense = 'edit-expense',
  AddDocuments = 'add-documents',
  Attendees = 'attendees',
  Tasks = 'tasks',
  AddCatering='add',
  EditCatering = 'edit',
  EditBooking = 'edit-booking',
  EditTask = 'editTask',
  AddTask = 'addTask',
  Virtual = 'virtual',
  MeetingRequest = 'meetingRequest',
  Booking='booking',
  CopyBooking = 'copybooking',
  MeetingDetails='meetingDetails',
  EditOverview = 'edit-overview',
  MeetingRequestCatering='catering',
  OverviewEmail = 'overview-email',
  ChangeSpace = 'change-space',
  releaseBookings = 'release-bookings'
}
